module.exports = __webpack_public_path__ + "static/media/medicationLog.2513f2c8.png";